module.exports = __webpack_public_path__ + "img/26 grande.50fb3747.jpg";